<template>
  <div class="header">
    <div class="text-center item" :key="`menu_${i}`" v-for="(m,i) in deviceMenus" @click="changePage(m,i)">
      <div>
        <img :src="m.isActive?m.activeSrc: m.src" style="height: 40px"/>
      </div>
      <div class="offset-top">
        <span :active="m.isActive&&true"><b v-text="m.text"></b></span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderMenu',
  data () {
    return {}
  },
  computed: {
    ...mapState(['deviceMenus'])
  },
  methods: {
    changePage (menu, i) {
      // 跳转到指定页面
      this.$router.replace({ name: menu.name })
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.header {
  height: 70px;
  display: flex;
  align-items: center;
  background-color: @base-white;
  padding: 0px 25px;
  .item {
    cursor: pointer;
    min-width: 140px;
    span {
      color: #555555;
      font-size: 15px;
    }
    span[active] {
      color: #262626;
    }
    .offset-top {
      margin-top: -6px
    }
  }
  .user {
    margin-left: 38px;
  }
  .right {
    display: flex;
    padding-top: 8px
  }
}
</style>
